<div>
    <!-- Basic Data -->
    <div class="col-md-12 col-12 col-sm-12" style="padding-top: 15px; margin-top: 0px; padding-left: 15px; margin-bottom: 0px; padding-bottom: 15px;">
        <div class="col-md-6 col-6 col-sm-6" style="display: inline-block; padding: 0px;">
            <span style="font-weight: 500; line-height: 1.2; color: #212529; font-size: 1.4rem;">{{stageInfo.stageName}} Stage</span>
            
        </div>
        <div class="col-md-6 col-6 col-sm-6" style="display: inline-block; text-align: right; padding-right: 0px; vertical-align: top;">
            <span class="btn-darkBlue brdrRadius3" *ngIf="!proj.EDT" title="Create Task" (click)="openTaskEntryModal()" style="cursor:pointer; padding: 4px 10px; font-size: 14px;">
                <i class="zmdi zmdi-plus btnIcon" style="margin-right: 3px;"></i> <span class="btnTxt">Create Task</span>
            </span>
            <span class="btn-darkBlue inLneBlk brdrRadius3" *ngIf="!proj.EDT" style="margin-left: 10px; padding: 4px 10px 4px; font-size: 14px;" (click)="openCNEntryModal(mdlCNEntry)"> 
                <i class="zmdi zmdi-check btnIcon" style="margin-right: 3px;"></i> <span class="btnTxt">Mark Stage Done</span>
            </span>
            <span class="lableBtnGray inLneBlk brdrRadius3" (click)="deleteStage()" *ngIf="stageInfo.isDeletable" title="Delete"
                    style="margin-left: 10px; padding: 3px 11px !important;">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
            </span>
            <i class="closeMdl zmdi zmdi-close" style="top: -7px; left: 0px; padding: 8px  12px !important; margin-left: 10px;" (click)="closeModel('')"></i>
        </div>
        <div>
            <div style="margin-top: 5px; display: flex;">

                <span  class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-right: 5px; font-size: 12px; padding: 4px 10px;">
                    Project <span style="font-size: 12px; font-weight: 600;">
                        {{projectName}}
                    </span>
                </span>
                <!--Started date-->
                <span  class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-right: 5px; font-size: 12px; padding: 4px 10px;">
                    Started {{((stageInfo.startDT | todayTommorow) == 'Today' || (stageInfo.startDT | todayTommorow) == 'Tomorrow' || (stageInfo.startDT | todayTommorow) == 'Yesterday') ? '' : 'on' }}
                    <span style="font-size: 12px; font-weight: 600;"> {{stageInfo.startDT | todayTommorow}}</span>
                </span>
                <!--change date-->
                <span  class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-right: 5px; font-size: 12px; padding: 4px 10px;">
                    Due {{((stageInfo.dueDT | todayTommorow) == 'Today' || (stageInfo.dueDT | todayTommorow) == 'Tomorrow' || (stageInfo.dueDT | todayTommorow) == 'Yesterday') ? '' : 'on' }} <span style="font-size: 12px; font-weight: 600;"> {{stageInfo.dueDT| todayTommorow}}</span>
                    <!-- <span style="margin-left: 10px; cursor: pointer;"><i class="fa fa-pencil"></i></span> -->
                </span>

                <span  class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-right: 5px; font-size: 12px; padding: 4px 10px;"
                    *ngIf="stageInfo.doneDT">
                    Done {{((stageInfo.doneDT | todayTommorow) == 'Today' || (stageInfo.doneDT | todayTommorow) == 'Tomorrow' || (stageInfo.doneDT | todayTommorow) == 'Yesterday') ? '' : 'on' }} <span style="font-size: 12px; font-weight: 600;"> {{stageInfo.doneDT| todayTommorow}}</span>
                </span>
            </div> 
            <div class="brdrRadius3" *ngIf="stageInfo.instructionNotes != ''"
            style="margin-top: 15px; background-color: #9eb6be26; color: #212529; font-size: 12px; padding: 10px 10px;" >
                <div style="font-weight: bold; margin-bottom: 2px;">Instruction Notes</div>    
                <div style="color: #777;">{{stageInfo.instructionNotes}}</div>
            </div>
            <div class="brdrRadius3" *ngIf="stageInfo.conclusionNotes != ''"
            style="margin-top: 15px; background-color: #9eb6be26; color: #212529; font-size: 12px; padding: 10px 10px;" >
                <div style="font-weight: bold; margin-bottom: 2px;">Conclusion Notes</div>    
                <div style="color: #777;">{{stageInfo.conclusionNotes}}</div>
            </div>
        </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 webView" style="padding: 0px 5px; overflow-y: auto;  font-size: 13px; padding: 0px 15px;" *ngIf="taskDetails.length != 0">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th style="width: 14%;">Task</th>
                    <th style="width: 13%;"> Assigned by</th>
                    <th style="width: 13%; text-align: left;">Assigned to</th>	
                    <th style="width: 8%; text-align: left;">Started on</th>
                    <th style="width: 7%; text-align: left;">Due on</th>
                    <th style="width: 7%; text-align: left;">Status</th>
                    <th style="width: 7%; text-align: left;">Done on</th>
                    <th style="width: 0%; text-align: left;"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let t of taskDetails">
                    <td style="vertical-align: middle;">
                        <div style="font-size: 12px; margin-bottom: 0px; vertical-align: inherit;">
                            {{t.Task}} 
                        </div>
                        <div style="font-size: 12px; color: #777;" *ngIf="t.Detail != ''">{{t.Detail}}</div>
                    </td>

                    <td style="text-align: left; vertical-align: inherit;">{{t.FromUserName}}</td>
                    <td style="text-align: left; vertical-align: inherit;">{{t.ToUserName}}</td>
                    <td style="text-align: left; vertical-align: inherit;">	
                        {{t.CreatedDT | todayTommorow}}
                    </td>
                    <td style="text-align: left; vertical-align: inherit;">	
                        {{t.ExpCompletionDT | todayTommorow}}
                    </td>        
                    <td style="text-align: left; vertical-align: inherit;">	
                        <!-- 0 -> Pending, 1 -> Paused, 2 -> Cancelled, 3 -> Done  -->
                        {{t.StatusID == 0 ? 'Pending': (t.StatusID == 1 ? 'Paused' : (t.StatusID == 2 ? 'Cancelled' : 'Done'))}}
                    </td> 
                    <td style="text-align: left; vertical-align: inherit;">	
                        {{t.StatusID == 3 ? (t.DoneDT | todayTommorow) : '-'}}
                    </td> 
                    <td style="text-align: center; vertical-align: inherit;">
                        <div *ngIf="!t.TaskDoneImage && t.StatusID == 3">-</div>
                        <a *ngIf="t.TaskDoneImage && isGGL && t.StatusID == 3" target="_blank" href="{{domainLink}}{{t.TaskDoneImage}}">
                            <i class="fa fa-file-image-o orangeText"></i>
                        </a>
                        <div *ngIf="t.StatusID != 3" class="btn btn-orange brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.66em;" (click)="isGGL ? openTaskDoneModal(t,taskDoneImageUpload) : changeStatus(t)"> Done
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="taskDetails.length > 0" class="mobView" style="background-color: #f8f8f8; padding-top: 10px;">
        <div class="col-12 col-xs-12 col-sm-12" *ngFor="let t of taskDetails; index as i" style="cursor: pointer; background-color: #fff; padding: 15px;" [ngStyle]="{'margin-top': i == 0 ? '0px' : '10px'}">
            <div class="col-12 col-xs-12 col-sm-12" style="padding: 0px;">
                <div class="col-7 col-sm-8 col-xs-8" style="display: inline-block; padding: 0px; font-size: 14px;">
                    <span style="margin-right: 2px;"> {{t.Task}} </span>   
                    <span style="color: #999;"> (#{{t.TaskID}}) </span>
                    <span style="padding-left: 3px;">
                        <a *ngIf="t.TaskDoneImage && isGGL && t.StatusID == 3" target="_blank" href="{{domainLink}}{{t.TaskDoneImage}}">
                            <i class="fa fa-file-image-o orangeText"></i>
                        </a>
                        <div *ngIf="t.StatusID != 3" class="btn btn-orange brdrRadius3" style="padding: 0px 8px; font-size: 14px; line-height: 1.66em;" (click)="isGGL ? openTaskDoneModal(t,taskDoneImageUpload) : changeStatus(t)"> Done
                        </div>
                    </span>
                </div>
                <div class="col-5 col-sm-4 col-xs-4" style="text-align : right; display: inline-block; padding: 0px;">
                    <span class="{{t.Priority == 0 ? 'orangeText' : 'blueText'}}" *ngIf="t.Priority != 1" style="margin-right: 10px;" title="{{t.Priority == 2 ? 'Low Priority' : 'High Priority'}}">
                        <i class="zmdi {{(t.Priority == 0 ? 'zmdi-long-arrow-up' : (t.Priority == 2 ? 'zmdi-long-arrow-down' : ''))}} "></i>
                    </span>
                    <div style="display: inline-block; font-size: 14px;">
                        <span>
                            <i class="fa fa-calendar"></i> {{t.ExpCompletionDT | todayTommorow }}
                        </span>
                    </div>     
                </div>
            </div>
            
            <div class="col-12 col-sm-12 col-xs-12" style="display: inline-block; padding: 0px; font-size: 13px;">
                <div class="col-6" style="display: inline-block; padding: 0px;">
                    <p style="color: #999; margin: 0px;">{{t.StatusID == 0 ? 'Pending': (t.StatusID == 1 ? 'Paused' : (t.StatusID == 2 ? 'Cancelled' : 'Done'))}}</p>
                </div>
                <div class="col-6" style="display: inline-block; padding: 0px; text-align: right;">
                    <span style="color: #999; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; text-align: right;">{{t.ToUserName}}</span>
                </div>
            </div>
        </div>
    </div>
    
    <div *ngIf="taskDetails.length == 0 && !proj.EDT" (click)="openTaskEntryModal()" 
        style="margin: 0px 15px 15px; font-size: 12px; padding: 7px 15px; background-color: #e8842122; display: inline-block; 
            cursor: pointer; color: #e88421; border-radius: 3px;">
        <i class="fa fa-plus" style="margin-right:5px"></i>Click here to add a task.
    </div>

</div>

<!-- <div (click)="openCNEntryModal(mdlCNEntry)">Enter Conclusion Notes</div> -->

<!-- Conclusion Notes Entry Modal -->
<ng-template #mdlCNEntry let-modal>
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr">Enter Conclusion Notes</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeCNEntryModal()"></i>
                </div>
            </div>
        </div>
    </div>

    <!--Body-->
    <div class="modal-body" style="padding-bottom: 15px; padding-top: 0px;">
        <div>
            <span class="orangeBadge brdrRadius3 bgwhite orangeBrdr" style="margin-right: 5px; margin-bottom: 5px; font-size: 12px; padding: 4px 10px;">
                Stage: <span style="font-size: 12px; font-weight: 600;">
                    {{stageInfo.stageName}}
                </span>
            </span>
        </div>
        <div>
            <textarea class="form-control brdrColor" rows="2" [(ngModel)]="stageInfo.conclusionNotes"  style="padding: 7px;font-size: 12px !important; resize: none; margin-top:10px; border:1px solid #ddd;border-radius:3px !important;width: 100%;" maxlength="200"
                placeholder="Stage Conclusion Notes" tabindex="1">
            </textarea>
        </div>
    </div>
    <!-- WebView Footer -->
    <div class="modal-footer" style="border: none; text-align: left; float: left; justify-content: left !important; padding: 0px 15px 20px;">
        <span class="btn btn-darkGreen brdrRadius3" (click)="markStageDone()" style="font-size: 13px; padding: 2px 7px 2px; line-height: 1.66em;">
            <i class="fa fa-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</ng-template>

<!-- Upload Task Done Image -->
<ng-template #taskDoneImageUpload let-modal>
    <!--Header-->
    <div class="col-md-12 col-sm-12 col-12">
        <div class="row">
            <div class="col-md-10 col-sm-10 col-10" style="padding-left: 0px;padding: 10px 0px 0px 15px;">
                <h4 class="modal-title"><span style="font-size: 20px;">Complete Task </span></h4>
                <p style="color: gray; font-size: 13px; position: relative; top: -3px; margin-bottom: 0px;">Upload an attachment of the completed task.</p>
            </div>
            <div class="col-md-2 col-sm-2 col-2" style="padding-top: 15px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="modal.dismiss('Cross click')"></i>
            </div>
            <div class="col-md-12 col-sm-12 col-12 inLneBlk pdng" style=" text-align: left;margin-bottom: 15px;">
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px; padding: 0px;">
                    <span class="btn font13 btn-darkGreen-alt padLeft5 brdrRadius3 hvrInfo btnBottom"
                        style="width: fit-content; padding: 5px 12px" (click)="addAttechmentFile()" *ngIf="!fileName">
                        <i class="zmdi zmdi-file-plus" style="padding-right: 10px;"></i>Upload
                    </span>
                    <input type="file" id="addAttechment" fileread="fileUpload.val"
                        (change)="handleFileInput($event.target.files)" style="display: none;">
                    <img id="addAttechmentPreview" *ngIf="showImage" [src]="fileData" alt="" style="width: 200px;">
                    <div>
                        <span *ngIf="!showImage" style="font-size: 14px; color: #333; text-decoration: none;">{{fileName}}</span>
                    </div>
                    <div *ngIf="fileName" (click)="removeAttechUploadedFile()" style="margin-top: 15px;">
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <span class="btn-darkBlue brdrRadius3" style="cursor: pointer; border-radius: 3px; padding: 5px 8px !important; display: inline-flex; align-items: center; height: 34px; font-size: 13px;">
                                <i class="fa fa-trash" style="margin-right: 9px; font-size: 13px;"></i>Remove
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-12" style="margin-bottom: 15px;">
                <div class="btn btn-darkGreen brdrRadius3" (click)="saveTaskDoneImage()"
                    style="font-size: 13px; padding: 5px 8px; line-height: 18px; cursor: pointer;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i> Complete
                </div>
            </div>
        </div>
    </div>
</ng-template>